import { Injectable } from '@angular/core';
import {select, Store} from '@ngrx/store';
import * as fromSites from '../reducers';
import {Site} from '../../shared/models/site';
import {Observable} from 'rxjs';
import {map, skipWhile} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SiteGetInfoService {

  constructor(private store: Store<fromSites.AppState>) {}

  isOrderOpened(): Observable<boolean> {
    return this.store.pipe(
      select(fromSites.selectors.getSite),
      skipWhile((data: Site) => !data || (data && !data.subscriptions[0])),
      map((site: Site) => site.subscriptions[0].isOrderOpened)
    )
  }

  isServiceVideo(): Observable<boolean> {
    return this.store.pipe(
      select(fromSites.selectors.getSite),
      skipWhile((data: Site) => !data || (data && !data.subscriptions[0])),
      map((site: Site) => site.subscriptions[0].service.id === 2)
    )
  }

  isStatusOff(): Observable<boolean> {
    return this.store.pipe(
      select(fromSites.selectors.getSite),
      skipWhile((data: Site) => !data || (data && !data.subscriptions[0])),
      map((site: Site) => site.subscriptions[0].status === 1)
    )
  }
}
